import type { UsedVehicleListing, VehicleType } from '@/state/types';
import { VEHICLE_SPEC_LIST } from '@/data/vehicles';

/**
 * Phase 9.7.3 — Generator for the "Gebraucht"-Tab im Fahrzeug-Shop.
 *
 * 5 zufällige Used-Listings entstehen alle 5 Spieltage automatisch. Der
 * "Erneuern"-Button kostet 50 € und triggert sofortige Neugeneration.
 */

export const USED_REFRESH_INTERVAL_MS = 5 * 86_400_000; // 5 game-days
export const USED_LIST_SIZE = 5;
export const USED_REFRESH_FEE = 50;

/** Eligible vehicle types for the used market (excludes free/special items). */
const ELIGIBLE: VehicleType[] = [
  'LF', 'HLF', 'TLF', 'TSF', 'MTW', 'PKW', 'GW', 'SW', 'RW',
  'KTW', 'RTW', 'NEF',
];

export function generateUsedListings(now: number): UsedVehicleListing[] {
  const out: UsedVehicleListing[] = [];
  for (let i = 0; i < USED_LIST_SIZE; i++) {
    const type = ELIGIBLE[Math.floor(Math.random() * ELIGIBLE.length)];
    const spec = VEHICLE_SPEC_LIST.find((s) => s.type === type)!;
    const condition = 0.3 + Math.random() * 0.5; // 0.30 – 0.80
    const km = 30_000 + Math.floor(Math.random() * 50_001); // 30 000 – 80 000
    out.push({
      id: `used_${now}_${i}_${Math.random().toString(36).slice(2, 5)}`,
      type,
      cost: Math.round(spec.cost * 0.6),
      condition,
      totalKilometers: km,
      listedAt: now,
    });
  }
  return out;
}
